/**
 * Copyright © 2026 Adnuntius AS.
 */
import {StaticProvider} from '@angular/core';

import {AdnFormStateService} from '../../../components/util/adn-form-state.service';

export function isCopyModalComponent(content: any): boolean {
  return typeof content?.name === 'string' && content.name.includes('CopyModal');
}

/**
 * Modal search-select / money / labels can call the page's AdnFormStateService
 * singleton and mark the underlying edit form dirty. ngx-bootstrap accepts
 * extra providers for the modal injector, so isolated modals get a no-op
 * instead of mutating page unsaved-changes state.
 */
export function isolatedModalPageFormProviders(): StaticProvider[] {
  return [{
    provide: AdnFormStateService,
    useValue: {
      setCurrentForm() {},
      markDirty() {},
      isDirty() {
        return false;
      },
      deregister() {}
    }
  }];
}

export function copyModalPageFormProviders(): StaticProvider[] {
  return isolatedModalPageFormProviders();
}
